<template>
  <main class="c-app-content">
    <div class="c-app-title">
      <div>
        <h1>
          <img class="c-app-title__icon" src="../assets/images/icons/ico24-inbox-primary.svg"
               alt="opportunities"> Inbox
        </h1>
      </div>
      <ul class="c-app-breadcrumb breadcrumb">
        <li class="breadcrumb-item"><router-link to="/">Callio</router-link></li>
        <li class="breadcrumb-item"><router-link to="/inbox">{{ $t('inbox') }}</router-link></li>
      </ul>
    </div>
    <div class="col" v-if="firstLoading">
      <skeleton-loading>
        <row>
          <square-skeleton :boxProperties="{bottom: '10px', height: '30px'}"></square-skeleton>
        </row>
        <row>
          <square-skeleton :boxProperties="{bottom: '10px', height: '200px'}"></square-skeleton>
        </row>
      </skeleton-loading>
    </div>
    <div class="tile" v-else>
      <div class="c-action">
        <div class="row">
          <div class="col-lg-3 c-action__left">
                        <span class="c-action__count">
                            {{ $t('listSummary', [firstItemOfPage, lastItemOfPage, itemCount, $t('results')]) }}
                        </span>
          </div>
          <div class="col-lg-9 c-action__right">
            <b-tabs class="c-tabs-button" small pills v-model="filterFormModel.type" @input="search">
              <b-tab :title="$t('all')"></b-tab>
              <b-tab :title="$t('taskReminder')"></b-tab>
              <b-tab :title="$t('systemNotification')"></b-tab>
            </b-tabs>
            <user-group-select :model="filterFormModel" attribute="group" @change="search" is-filter :place-holder="$t('chooseGroup')" :ids="groupIds"
                               v-if="$store.state.user.permissions.find(p => p ==='notificationListAll' || p === 'notificationListGroup')"></user-group-select>
            <user-select :isFilter="true" :model="filterFormModel" attribute="user" :group-filter="filterFormModel.group"
                         v-if="$store.state.user.permissions.includes('notificationListAll') || $store.state.user.permissions.includes('notificationListGroup')" @change="search"
                         :place-holder="$t('selectUser')" :groups-filter="groupIds"></user-select>
            <time-range-picker :model="filterFormModel" :label="$t('time')" @change="search"></time-range-picker>
            <dropdown :model="filterFormModel" attribute="notRead" :right-menu="true" type="bordered" :options="[
                            {text: $t('allStatuses'), value: null},
                            {text: $t('notRead'), value: true}
                        ]" @change="search" :icon="'fa fa-thumb-tack'"></dropdown>
            <button class="btn btn-sm btn-primary" @click="search"><i class="fa fa-refresh mr-0"></i></button>
          </div>
        </div>
      </div>
      <div class="tile-body">
        <div class="c-inbox-list">
          <ul v-if="listLoading" class="text-center text-primary">
            <li>
              <b-spinner></b-spinner>
            </li>
          </ul>
          <ul v-if="!listLoading && itemCount">
            <li v-for="item in items" :key="item._id">
              <notification :item="item"></notification>
            </li>
          </ul>
        </div>
        <div v-if="!listLoading && !itemCount" class="text-center text-danger">
          <li>{{ $t('emptyList') }}</li>
        </div>
      </div>
    </div>
    <div class="c-paging" v-if="itemCount > filterFormModel.pageSize">
      <b-pagination size="sm" class="pagination pagination-sm justify-content-center"
                    v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                    @input="load">
      </b-pagination>
    </div>
  </main>
</template>

<script>
import list from '../mixins/List';
import Notification from "./Notification";
import Dropdown from "../components/Dropdown";
import UserSelect from "../components/UserSelect";
import TimeRangePicker from "../components/TimeRangePicker";
import _ from "lodash";
import UserGroupSelect from "@/components/UserGroupSelect";

export default {
  components: {UserGroupSelect, UserSelect, Dropdown, Notification, TimeRangePicker},
  mixins: [list],
  data: function () {
    return {
      service: '/notification',
      reloadBus: 'reloadNoti',
      autoLoad: false,
      showUser: false,
      defaultFilterFormModel: {
        type: 0,
        notRead: null,
        user: this.$store.state.user._id,
        group: null
      }
    }
  },
  methods: {
    search: _.debounce(function () {
      this.filterFormModel.page = 1;
      this.load();
    }, 200),
  },
  computed: {
    groupIds() {
      if (this.$store.state.user.permissions.includes('notificationListGroup') && !this.$store.state.user.permissions.includes('notificationListAll')) {
        return this.$store.state.user.roleGroups
      }
      return null
    }
  },
  mounted() {
    this.search();
  },
}
</script>
